import axios from 'axios'
import { endpoint } from '../config.js'

export function LOGIN(username, password) {
    return async(dispatch) => {
        return new Promise(async(resolve, reject) => {
            axios.post(`${endpoint}/api/auth/login`, {
                username: username,
                password: password,
            })
            .then(async(response) => {
                let userData = {
                    ...response.data.user,
                    token: response.data.token
                }        
                await localStorage.setItem('@JO:user', JSON.stringify(userData))
                dispatch({
                    type: 'SET_USER',
                    payload: userData
                })
                resolve(userData)
            })
            .catch(reject)
        
        })
    }
}

export function GET_CURRENT_USER(user) {
    return async (dispatch) => {
        
        const currUser = await axios({
            url: `${endpoint}/api/auth/current-user`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${user.token}`
            }, 
        })

        const updatedUser = {
            ...currUser.data.user,
            token: user.token
        }

        await localStorage.setItem('@JO:user', JSON.stringify(updatedUser));
        dispatch({
            type: 'SET_USER',
            payload : updatedUser
        });
        
    }
}


export function UPDATE_NAME(name) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                dispatch({
                    type: 'UPDATE_NAME',
                    payload: name
                })
                resolve(name)
            }, 1000)
        })
    }
}

export function UPDATE_USER(userObject) {
    return async (dispatch, state) => {
        return new Promise(async (resolve, reject) => {
            // const currUser = state().user.user
            const data = new FormData();

            data.append('_id', userObject._id)
            data.append('username', userObject.username)
            data.append('display_name', userObject.display_name)
            data.append('city', userObject.city)

            if(userObject.push_token) {
                data.append('push_token', userObject.push_token)
            }

            if(userObject.friend_requests.length) {
                data.append('friend_requests', JSON.stringify(userObject.friend_requests))
            }
            if(userObject.bio.length) {
                data.append('bio', userObject.bio)
            }
            if(userObject.pronouns.length) {
                data.append('pronouns', userObject.pronouns)
            }
            if(userObject.avatarFile) {
                data.append('avatarFile', userObject.avatarFile)
            }
            axios({
                url: `${endpoint}/api/users/${userObject._id}`,
                method: 'POST',
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${userObject.token}`,
                    'content-type': 'multipart/form-data',
                },
            }).then( async (res) => {
                let updatedUser = {
                    ...userObject,
                    ...res.data.user
                }
                await localStorage.setItem('@JO:user', JSON.stringify(updatedUser))

                dispatch({
                    type: 'SET_USER',
                    payload: {
                        ...userObject,
                        ...res.data.user
                    }
                })
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
    }
}

export function GET_USERS(s = '') {
    return async (dispatch, state) => {
        const currUser = state().user.user
        const users = await axios({
            url: `${endpoint}/api/users?s=${s}`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${currUser.token}`,
            },
        })
        dispatch({
            type: "SET_USERS",
            payload: users.data.users
        })
    }
}

export function SEND_REQUEST(id) {
    return (dispatch, state) => {
        return new Promise(async (resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/friend-request`,
                method: 'POST',
                data: {
                    friend: id
                },
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve(res.data)
                dispatch({
                    type: 'UPDATE_SENT_FRIEND_REQUESTS',
                    payload: res.data.user.sent_friend_requests
                })
            })
         })    
    }
}

export function REFUSE_REQUEST(id) {
    return (dispatch, state) => {
        return new Promise(async (resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/friend-request/${id}/refuse`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'UPDATE_FRIEND_REQUESTS',
                    payload: res.data.user.friend_requests
                })
                resolve(res.data.message)
            })   
        })    
    }
}

export function REVOKE_REQUEST(id) {
    return (dispatch, state) => {
        return new Promise(async (resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/friend-request/${id}/revoke`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'UPDATE_SENT_FRIEND_REQUESTS',
                    payload: res.data.user.sent_friend_requests
                })
                resolve(res.data.message)
            })   
        })    
    }
}

export function ACCEPT_REQUEST(id) {
    return (dispatch, state) => {
        return new Promise(async (resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/friend-request/${id}/accept`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'SET_USER',
                    payload: {...res.data.user, token: token}
                })
                resolve(res.data.message)
            })   
        })    
    }
}

export function GET_PROFILE_BY_ID(id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user

            axios({
                url: `${endpoint}/api/users/${id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve(res.data.user)
            })  
        })
         
    }
}

export function REMOVE_FRIEND(id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user

            axios({
                url: `${endpoint}/api/friends/${id}/remove`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'SET_USER',
                    payload: {
                        ...res.data.user,
                        token: token
                    }
                })
                resolve(res.data)
            })  
        })
         
    }
}

export function ADD_BLOCK(_id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user

            axios({
                url: `${endpoint}/api/users/add-block/${_id}`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'SET_USER',
                    payload: {
                        ...res.data.user,
                        token: token
                    }
                })
                resolve(res.data.user)
            })  
        })
    }
}

export function UNBLOCK(_id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user

            axios({
                url: `${endpoint}/api/users/remove-block/${_id}`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'SET_USER',
                    payload: {
                        ...res.data.user,
                        token: token
                    }
                })
                resolve(res.data.user)
            })  
        })
    }
}

export function DELETE_USER() {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/users/delete`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve()
            })
        })
    }
}

export function UPLOAD_PHOTO(photo) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token, _id } = state().user.user
            const data = new FormData() 
            data.append('photoFile', photo)
            axios({
                url: `${endpoint}/api/users/${_id}/photos/add`,
                method: 'POST',
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve(res)
            })
        })
    }
}

export function REMOVE_PHOTO(photoId) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token, _id } = state().user.user
            axios({
                url: `${endpoint}/api/users/${_id}/photos/remove/${photoId}`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve()
            })
        })
    }
}